import React from "react";
import { Search, Scale, Zap, FileText, Users } from "lucide-react";
import { LIFECYCLE } from "../../data/content";

const icons = [Search, Scale, Zap, FileText, Users];

export default function Lifecycle() {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
      {LIFECYCLE.map((l, i) => {
        const Icon = icons[i];
        return (
          <div
            key={l.step}
            className="relative rounded-xl border border-white/10 bg-navy-900/60 p-5 hover:border-primary/30 transition-colors"
          >
            <span className="text-xs font-mono text-primary/70">0{i + 1}</span>
            <span className="mt-3 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary/12 text-primary">
              <Icon className="h-5 w-5" />
            </span>
            <h3 className="mt-3 text-base font-semibold text-foreground uppercase tracking-wide">
              {l.step}
            </h3>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{l.desc}</p>
          </div>
        );
      })}
    </div>
  );
}
